import React from "react";
import { Dimensions, Image, TouchableOpacity, View } from "react-native";
import * as WebBrowser from "expo-web-browser";

import style from "./style";
import { getRecursURL } from "../../Functions/getRecurs";

/*
    textSocial = {textSocial : text que volem compartir , peticio : text que volem mostrar al cenobify }
*/

function XarxesSocials(RouterData, token, textSocial) {
  const { recursos, idioma } = RouterData.route.params;

  const _handlePressButtonAsync = async (link) => {
    let result = await WebBrowser.openBrowserAsync(link);
  };

  return (
    <View style={[style.xarxesContainer]}>
      <View
        style={{
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "row",
        }}
      >
        {/* FB */}
        <TouchableOpacity
          style={{
            height: Dimensions.get("screen").height * (13 / 15) * 0.67 * 0.11,
            width: Dimensions.get("screen").height * (13 / 15) * 0.67 * 0.11,
          }}
          onPress={() => {
            _handlePressButtonAsync(
              "https://www.facebook.com/sharer/sharer.php?u=" +
                constants.hrefXarxesProjecte +
                "&t=" +
                textSocial.textSocial,
            );
            // postStadistic({token:token, tipus_peticio: "Compartir xarxes", peticio: "Compartir en Facebook( "+ textSocial.peticio + " )" })
          }}
        >
          <Image
            style={{
              width: "100%",
              height: "90%",
              alignSelf: "center",
              resizeMode: "contain",
            }}
            source={{
              uri: getRecursURL(recursos, "perfil_facebook", idioma),
            }}
          />
        </TouchableOpacity>

        {/* TW  */}
        <TouchableOpacity
          style={{
            height: Dimensions.get("screen").height * (13 / 15) * 0.67 * 0.11,
            width: Dimensions.get("screen").height * (13 / 15) * 0.67 * 0.11,
          }}
          onPress={() => {
            _handlePressButtonAsync(
              "https://twitter.com/intent/tweet?text=" + textSocial.textSocial,
            );
            // postStadistic({token:token, tipus_peticio: "Compartir xarxes", peticio: "Compartir en Twitter( "+ textSocial.peticio + " )" })
          }}
        >
          <Image
            style={{
              width: "100%",
              height: "90%",
              alignSelf: "center",
              resizeMode: "contain",
            }}
            source={{
              uri: getRecursURL(recursos, "perfil_twitter", idioma),
            }}
          />
        </TouchableOpacity>

        {/* WSP  */}
        <TouchableOpacity
          style={{
            height: Dimensions.get("screen").height * (13 / 15) * 0.67 * 0.11,
            width: Dimensions.get("screen").height * (13 / 15) * 0.67 * 0.11,
          }}
          onPress={() => {
            _handlePressButtonAsync(
              "whatsapp://send?text=" + textSocial.textSocial,
            );
            // postStadistic({token:token, tipus_peticio: "Compartir xarxes", peticio: "Compartir en Whatsapp( "+ textSocial.peticio + " )" })
          }}
        >
          <Image
            style={{
              width: "100%",
              height: "90%",
              alignSelf: "center",
              resizeMode: "contain",
            }}
            source={{
              uri: getRecursURL(recursos, "perfil_whatsapp", idioma),
            }}
          />
        </TouchableOpacity>
      </View>
    </View>
  );
}

export default XarxesSocials;
